import { SearchFilter } from "@modules/study/search";
import { SearchFilter2 } from "@modules/study/search/search_filter2";
import API from "@unisearch/helpers/api";
import { objectToQueryString } from "@unisearch/helpers/utils";
import { LayoutMain } from "@unisearch/theme/layout";

const SearchSpPage = ({
  searchParams,
  location,
  courseLevel,
  specialization,
  examType,
  fees,
  courseDuration,
  filterResult,
  loading,
  pageUrl,
  initSp,
  initCrlvl,
  initCo,
}) => {
  const params = {
    ...searchParams,
    ...(searchParams.crlvl && { crlvl: searchParams.crlvl.split(",") }),
    ...(searchParams.st && { st: searchParams.st.split(",") }),
    ...(searchParams.sp && { sp: searchParams.sp.split(",") }),
    ...(searchParams.ex && { ex: searchParams.ex.split(",") }),
    ...(searchParams.co && { co: searchParams.co.split(",") }),
    ...(searchParams.ci && { ci: searchParams.ci.split(",") }),
  };

  return (
    <LayoutMain
      title="Search University"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/search`}
    >
      <SearchFilter2
        searchParams={params}
        location={location}
        courseLevel={courseLevel}
        specialization={specialization}
        examType={examType}
        fees={fees}
        courseDuration={courseDuration}
        filterResult={filterResult}
        loadings={loading}
        pageUrl={pageUrl}
        initSp={initSp}
        initCrlvl={initCrlvl}
        initCo={initCo}
      />
    </LayoutMain>
  );
};
export default SearchSpPage;

export async function getServerSideProps({ query }) {
  const initQuery = query.searchpages;
  const pageUrl = `/search/${initQuery.join("/")}`;
  const obj = { ref: "general" };
  if (initQuery[0]) {
    obj.sp = initQuery[0];
  }
  if (initQuery[1]) {
    obj.crlvl = initQuery[1];
  }
  if (initQuery[2]) {
    obj.co = initQuery[2];
  }

  let props = {
    searchParams: {},
    location: [],
    courseLevel: [],
    specialization: [],
    examType: [],
    fees: {},
    courseDuration: {},
    filterResult: {},
    pageUrl,
    initSp: initQuery[0] ?? "",
    initCrlvl: initQuery[1] ?? "",
    initCo: initQuery[2] ?? "",
  };

  try {
    const res = await API.get(`/search?${objectToQueryString(obj)}`);

    if (!res.error) {
      const {
        searchParams,
        location,
        courseLevel,
        specialization,
        examType,
        fees,
        courseDuration,
        filterResult,
      } = res.data;
      props.searchParams = searchParams ?? {};
      props.location = location ?? [];
      props.courseLevel = courseLevel ?? [];
      props.specialization = specialization ?? [];
      props.examType = examType ?? [];
      props.fees = fees ?? {};
      props.courseDuration = courseDuration ?? {};
      props.filterResult = filterResult ?? {};
    }
    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
